import React from 'react';
import formatPhoneNumber from '../../../lib/formatPhoneNumber';
import { Button, TextArea } from '../../shared/_form';
import { Tooltip } from '../../shared/_tooltip';
import { Field } from 'redux-form/immutable';
import PropTypes from 'prop-types';
import moment from 'moment/moment';
import Immutable from 'immutable';

const BookedAppointmentTooltip = ({ date, rep, caterer, appointment, loading, id, onHandleClose, renderAppointmentTime, onHandleNotesSubmit, onHandleCancelAppointment, renderError }) => (
  <Tooltip className='calendar__day__appointment-tooltip'
    header={ date.format('MMMM D, YYYY') }
    id={ id }
    onClose={ onHandleClose }>
    { renderAppointmentTime() }

    <div className='calendar__day__appointment-tooltip__body'>
      <div className='calendar__day__appointment-tooltip__divider' />

      <div className='calendar__day__appointment-tooltip__body__row'>
        <span className='calendar__day__appointment-tooltip__body__label'>REP:</span> { rep.get('name') }
      </div>
      <div className='calendar__day__appointment-tooltip__body__row'>
        <span className='calendar__day__appointment-tooltip__body__label'>COMPANY:</span> { rep.get('company') }
      </div>
      <div className='calendar__day__appointment-tooltip__divider' />

      <div className='calendar__day__appointment-tooltip__body__row'>
        <span className='calendar__day__appointment-tooltip__body__label'>SPECIALTY:</span> { rep.get('specialty') }
      </div>
      <div className='calendar__day__appointment-tooltip__body__row'>
        <span className='calendar__day__appointment-tooltip__body__label'>PHONE NUMBER:</span> { formatPhoneNumber(rep.get('phoneNumber')) }
      </div>
      <div className='calendar__day__appointment-tooltip__body__row'>
        <span className='calendar__day__appointment-tooltip__body__label'>EMAIL:</span> { rep.get('email') }
      </div>
      <div className='calendar__day__appointment-tooltip__body__row'>
        <span className='calendar__day__appointment-tooltip__body__label'>DRUGS:</span> { rep.get('products') }
      </div>
      <div className='calendar__day__appointment-tooltip__divider' />

      <div className='calendar__day__appointment-tooltip__body__row'>
        <span className='calendar__day__appointment-tooltip__body__label'>CATERING:</span> { caterer.get('name') }
      </div>

      <form onSubmit={ onHandleNotesSubmit }>
        <div className='calendar__day__appointment-tooltip__body__row'>
          <div className='calendar__day__appointment-tooltip__body__label'>NOTES:</div>
          <div className={ 'calendar-tooltip__note' }>
            <Field className='calendar__day__appointment-tooltip__text-area' component={ TextArea } name={ `notes${appointment.get('id')}` } />
            {renderError()}
          </div>
        </div>
        <div className='form__submit form__submit--space-between'>
          <Button className='form__button form__button--purple' loading={ loading } onClick={ onHandleCancelAppointment } type='button'>Cancel Appt.</Button>
          <Button className='form__button form__button--green' disabled={ loading } type='submit'>Save</Button>
        </div>
      </form>
    </div>
  </Tooltip>

);

BookedAppointmentTooltip.propTypes = {
  appointment:                  PropTypes.instanceOf(Immutable.Map),
  caterer:                      PropTypes.object.isRequired,
  date:                         PropTypes.instanceOf(moment),
  formValues:                   PropTypes.instanceOf(Immutable.Map),
  loading:                      PropTypes.bool,
  onHandleCancelAppointment:    PropTypes.func.isRequired,
  onHandleClose:                PropTypes.func.isRequired,
  onHandleNotesSubmit:          PropTypes.func.isRequired,
  renderAppointmentTime:        PropTypes.func.isRequired,
  rep:                          PropTypes.instanceOf(Immutable.Map)
};

export default BookedAppointmentTooltip;



// WEBPACK FOOTER //
// ./app/components/managers/calendar/_BookedAppointmentTooltip.jsx